<template>
    <div v-if="student" class="obj-list" :class="{ pointer: isCoach }" @click="showObjectivesDialog">
        <div v-for="(objective, i) in objectives" :key="i" class="obj-item">
            {{ objective }}
        </div>
        <div v-if="objectives.length === 0" class="obj-item obj-item--empty">
            {{ $t('common.no_objectives') }}
        </div>
        <objectives-student-dialog ref="objectives" :value="objectives" :student-id="studentId" @saved="$emit('saved')" />
    </div>
</template>

<script>
import ObjectivesStudentDialog from '../../coach/ObjectivesStudentDialog.vue';
export default {
    components: { ObjectivesStudentDialog },
    name: "ObjectivesProfile",
    props: {
        student: {
            type: Object,
            default: null,
        }
    },
    computed: {
        objectives(vm = this) {
            return vm.student?.objectives || []
        },
        studentId(vm = this) {
            return vm.student?.id || null
        },
        isCoach(vm = this) {
            return vm.accountType === 'coach' || vm.accountType === 'company'
        }
    },
    methods: {
        showObjectivesDialog() {
            const vm = this;
            if (!vm.isCoach) return;
            vm.$refs.objectives.show()
        }
    }
}
</script>

<style scoped>
.obj-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.obj-item {
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 10px;
    padding: 11px 14px;
    font-size: 14px;
    font-weight: 500;
    color: var(--v-txtPrimary-base);
}

.obj-item--empty {
    color: var(--v-txtMuted-base);
}
</style>
